import { render } from "./HOABulletin.vue?vue&type=template&id=c0c86d56"
const script = {}

import "./HOABulletin.vue?vue&type=style&index=0&id=c0c86d56&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__